<template>
  <v-layout justify-center>
    <v-dialog content-class="bra-20" v-model="dialog" persistent :max-width="widthBody" :retain-focus="false">
      <v-card>
        <v-card-title>
          <span>{{ title }}</span>
          <v-spacer />
          <v-icon v-if="icon && icon.length > 0" :color="color">{{ icon }}</v-icon>
          <v-btn v-else color="#000" icon class="ml-n3" @click="fechar()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="mt-5">
          <slot name="body">
            <v-virtual-scroll
              :items="messages"
              height="100"
              item-height="18"
            >
              <template v-slot:default="{ item }">
                <p>{{ item }}</p>
              </template>
            </v-virtual-scroll>
          </slot>
        </v-card-text>

        <v-card-actions class="mt-n4">
          <slot name="opcoes">
            <v-spacer></v-spacer>
            <v-btn text @click="confirmar()" :color="color">confirmar</v-btn>
          </slot>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'DialogError.vue',
  model: {
    prop: 'dialog',
    event: 'change-dialog'
  },
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: "Confirmação"
    },
    messages: {
      type: Array,
      default: () => ([])
    },
    color: {
      type: String,
      default: 'primary'
    },
    icon: String,
    widthBody: {
      type: String,
      default: '400px'
    }
  },
  methods: {
    fechar () {
      this.$emit('change-dialog', false)
    },
    confirmar () {
      this.$emit('confirmado', true)
      this.fechar()
    }
  }
}
</script>
